import Close16 from '@carbon/icons-react/es/close/16';
import { Button as AntButton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Drawer as DrawerAtom } from 'components/atoms/drawer';
import { Form as FormAtom } from 'components/atoms/form';

export const Drawer = styled(DrawerAtom).attrs({
  width: 360,
  placement: 'right',
  closable: true,
  closeIcon: <Close16 />,
  mask: true,
  destroyOnClose: true,
})`
  .ant-drawer-body {
    padding: 0;
  }
`;

const StyledForm = styled(FormAtom).attrs({
  layout: 'inline',
})`
  margin-bottom: var(--spacing-05);

  ${FormAtom.Item} {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 0;
    margin-bottom: 0;

    &:last-child {
      margin-right: 0;
    }
  }

  .ant-form-item-label > label::after {
    display: none;
  }

  .ant-form-item-control-input {
    margin-bottom: 0;
  }
`;

type Form = typeof StyledForm & { Item: typeof FormAtom['Item'] };

const Form: Form = StyledForm as any;

Form.Item = FormAtom.Item;

export { Form };

export const Duration = styled(Form.Item)`
  width: 204px;
`;

export const Notes = styled(Form.Item)`
  width: 328px;

  .ant-form-item-control {
    width: 328px;
  }
`;

export const Categories = styled(Form.Item)`
  width: 328px;

  .ant-form-item-control {
    width: 328px;
  }
`;

export const Row = styled.div`
  display: flex;
  height: 32px;
  align-items: center;
`;

export const InlineButton = styled(AntButton).attrs({
  size: 'small',
  type: 'link',
})`
  &&& {
    --hover-color: transparent;
    padding: 0;
    height: auto;
    border: none;
    margin-right: var(--spacing-02);
    height: var(--line-height-body-short-01);

    span {
      max-width: 250px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;

export const ButtonGroup = styled.div<{
  $space?: number;
  $reversed?: boolean;
  $vertical?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $reversed = false, $vertical = false }) =>
    `${$vertical ? 'column' : 'row'}${$reversed ? '-reverse' : ''}`};
  gap: ${({ $space: $size = 16 }) => `${$size}px`};

  ${Button} {
    flex: 1;
  }
`;
